/* @flow */

import { NavLink } from 'react-router-dom';

export default NavLink;



// WEBPACK FOOTER //
// ./src/ui/components/core/NavLink.js